import axios from 'axios';

import { mixUrlWithParamns } from '../utils/objectManipulations';
import { clearLocalStorage } from '../utils/localStorage';
import { toast } from "react-toastify";

export const basePath =
	window.location.origin === 'http://localhost:3000' ? 'http://localhost:8080' : window.location.origin;
export const isLocalRequest = basePath === 'http://localhost:8080';
export const apiBasePath = `${basePath}/api`;
export const createGetQueryToken = (path, queryData) => `${basePath}/api/${path}?${queryData || ''}`;

export const logOff = () => {
	clearLocalStorage();
	window.location.assign(`${process.env.REACT_APP_TROCAR_APP_URL}/application/Login/logoff`);
};

export const getApplicationToken = () => {
	let data = window.localStorage.getItem('userData');
	if (data) {
		data = JSON.parse(data);
		return data.user.token;
	}
	return null;
}

export async function requestFromServer(_path, _method = 'GET', _body = null, _withCredentials = true, _config = {}) {
	let data = null;

	if (_withCredentials) {
		data = window.localStorage.getItem('userData');
		if (data) {
			data = JSON.parse(data);
			if (data.user && data.user.token) {
				axios.defaults.headers.common = {
					Authorization: `Bearer ${data.user.token}`
				};
			}
		}
	}

	if (_body && _method === 'GET') {
		_path = mixUrlWithParamns(_path, _body);
	}

	try {
		const response = await axios({
			method: _method,
			url: `${basePath}/api/${_path}`,
			data: ['POST', 'PUT'].indexOf(_method) !== -1 && _body,
			..._config,
		});
		return Promise.resolve(response);
	} catch (error) {
		if (error.response.status === 401) {
			toast.error('Você não possui permissão para executar essa ação. Por favor, contate o suporte.');
			return setTimeout(logOff(), 1000);
		} else {
			throw error;
		}
	}
}

export async function uploadToServer(_path, _files, _onProgress = null) {
	let data = null;

	data = window.localStorage.getItem('userData');
	if (data) {
		data = JSON.parse(data);
		if (data.user && data.user.token) {
			axios.defaults.headers.common = {
				Authorization: `Bearer ${data.user.token}`
			};
		}
	}

	const formData = new FormData();
	if (_files.length > 1) {
		_files.forEach((_file, index) => {
			formData.append(`file${index}`, _file);
		});
	} else {
		formData.append(`file`, _files[0]);
	}

	try {
		const response = await axios({
			method: 'post',
			url: `${basePath}/api/${_path}`,
			data: formData,
			headers: {
				'content-type': 'multipart/form-data',
			},
			onUploadProgress: progressEvent => _onProgress && _onProgress(progressEvent.loaded / progressEvent.total)

		});
		return Promise.resolve(response);
	} catch (error) {
		if (error.response.status === 401) {
			toast.error('Você não possui permissão para executar essa ação. Por favor, contate o suporte.');
			return setTimeout(logOff(), 1000);
		} else {
			throw error;
		}
	}
}
